import styles from './style/ModalASK.module.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectASK, updateASK } from '../../../store/slice/tdp/ask';
import { deepClone } from '../../../utils';

import { MdEdit, MdEditNote } from 'react-icons/md';

import Modal from '../../Utilities/Modal';
import TextField from '../../Utilities/TextField';
import Button from '../../Utilities/Button';
import TextArea from '../../Utilities/TextArea';
import Table from '../../Utilities/Table';
import Toast from '../../Utilities/Toast';

const ModalASK = ({ status, setStatus, setIsOpen, isOpen, code }) => {
  const dispatch = useDispatch();
  const { ask_detail, updated } = useSelector(selectASK);

  const [item, setItem] = useState('');
  const [original, setOriginal] = useState('');
  const [inertia, setInertia] = useState([]);

  const [id, setId] = useState(-1);
  const [type, setType] = useState('');
  const [content, setContent] = useState('');
  const [contentLanguage, setContentLanguage] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    setItem(status[code?.code]);
    setOriginal(status.item);
    setInertia(status.ability_ask_item);
  }, [dispatch, status, code]);

  useEffect(() => {
    setInertia(ask_detail);
  }, [ask_detail]);

  const handleUpdate = () => {
    if (!handleValidate()) {
      const array = [];
      inertia.forEach((data) => {
        array.push({
          level: data.level,
          inertia: data.inertia || '-',
          content: data.content,
          multilingual: {
            inertia: data[code?.code].inertia || '-',
            content: data[code?.code].content,
          },
        });
      });

      const postObj = {
        askID: status.id,
        code: code?.value,
        category: status.category,
        item: original,
        multilingual: item,
        ability_ask_item: array,
      };
      dispatch(updateASK(postObj));

      setIsOpen(false);
      setInertia([]);
      setError(false);
      setTimeout(() => {
        setItem('');
      }, 1500);
    }
  };

  const handleCancel = () => {
    setStatus('');
    setIsOpen(false);
    setItem('');
    setInertia([]);
    setError(false);

    setId('');
    setType('');
    setContent('');
    setContentLanguage('');
  };

  const handlePopup = (data, index, type) => {
    setId(index);
    setType(type);
    if (type === 'original') {
      setContent(data.content);
    } else {
      setContentLanguage(data[code?.code].content);
    }
  };

  const handleSave = (index, type) => {
    const array = deepClone(inertia);
    if (type === 'original') {
      array.forEach((data, idx) => {
        if (index === idx) {
          data.content = content;
        }
      });
    } else {
      array.forEach((data, idx) => {
        if (index === idx) {
          data[code?.code].content = contentLanguage;
        }
      });
    }
    setInertia(array);
    setContent('');
    setType('');
    setId('');
  };

  const handleValidate = () => {
    let error = false;
    let count = 0;

    if (!item || inertia?.length <= 0) {
      count++;
    }

    if (inertia?.length > 0) {
      inertia.forEach((data) => {
        if (!data.content || data.content.length <= 0) count++;
      });
    }

    if (count) {
      error = true;
      setError(true);
    } else {
      error = false;
      setError(false);
    }

    return error;
  };

  const headerData = [
    {
      title: '慣性行為層次',
      width: 20,
    },
    {
      title: '慣性行為描述',
      width: 40,
    },
    {
      title: '原始資料',
      width: 40,
    },
  ];

  return (
    <>
      <Modal size='xl' isOpen={isOpen}>
        <div className={styles.modalHeader}>
          <div className={styles.modalSubHeader}>
            <div className={styles.modalTitle}>
              <MdEditNote className={styles.modalIcon} />
              查看職能慣性項目
            </div>
          </div>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.colHalf}>
            <div className={styles.leftWrapper}>
              <label className={styles.labelTitle}>ASK 職能慣性類別</label>
              <span>{status.category?.substring(0, 1)}</span>
            </div>
            <div className={styles.rightWrapper}>
              <label className={styles.labelTitle}>職能項目</label>
              <TextField value={item} onChange={(e) => setItem(e)} error={error && !item} />
              {error && !item && <span className={styles.messageError}>未輸入職能項目</span>}
            </div>
            <div className={styles.rightWrapper}>
              <label className={styles.labelTitle}>原始資料</label>
              <TextField value={original} onChange={(e) => setOriginal(e)} error={error && !item} />
              {error && !item && <span className={styles.messageError}>未輸入職能項目</span>}
            </div>
          </div>
          <div className={styles.title}>慣性行為列表</div>
          <Table header={headerData} type={'condensed'} nonSticky>
            {inertia?.length > 0 && (
              <tbody>
                {inertia?.map((data, index) => (
                  <tr key={index}>
                    <td width={`${headerData[0].width}%`}>
                      <strong>L{data.level}</strong>
                    </td>
                    <td width={`${headerData[1].width}%`}>
                      <div className={styles.editWrapper}>
                        <div className={styles.desc}>{data[code?.code]?.content}</div>

                        <span className={styles.btnEdit}>
                          <Button type='pure' icon={<MdEdit className={styles.icon} />} onClick={() => handlePopup(data, index, 'multilingual')} />
                        </span>

                        {Number(id) === Number(index) && type === 'multilingual' && (
                          <div className={styles.modalEdit}>
                            <div className={styles.modalTitle}>慣性行為描述</div>
                            <TextArea value={contentLanguage} onChange={(e) => setContentLanguage(e.target.value)} />
                            <div className={styles.modalButton}>
                              <Button
                                type='quaternary'
                                title='取消'
                                onClick={() => {
                                  setId('');
                                  setType('');
                                  setContentLanguage('');
                                }}
                              />
                              <div className={styles.modalBtn}>
                                <Button type='primary' title='儲存' onClick={() => handleSave(index, 'multilingual')} disabled={!contentLanguage} />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>

                    <td width={`${headerData[2].width}%`}>
                      <div className={styles.editWrapper}>
                        <div className={styles.desc}>{data?.content}</div>

                        <span className={styles.btnEdit}>
                          <Button type='pure' icon={<MdEdit className={styles.icon} />} onClick={() => handlePopup(data, index, 'original')} />
                        </span>

                        {Number(id) === Number(index) && type === 'original' && (
                          <div className={styles.modalEdit}>
                            <div className={styles.modalTitle}>原始資料</div>
                            <TextArea value={content} onChange={(e) => setContent(e.target.value)} />
                            <div className={styles.modalButton}>
                              <Button
                                type='quaternary'
                                title='取消'
                                onClick={() => {
                                  setId('');
                                  setType('');
                                  setContent('');
                                }}
                              />
                              <div className={styles.modalBtn}>
                                <Button type='primary' title='儲存' onClick={() => handleSave(index, 'original')} disabled={!content} />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </div>

        <div className={`${styles.modalFooter} ${styles.right}`}>
          <span style={{ marginRight: '8px' }}>
            <Button type='quaternary' title='取消' onClick={handleCancel} style={{ marginRight: '8px' }} disabled={content} />
          </span>
          <Button type='primary' title='儲存' onClick={handleUpdate} disabled={content} />
        </div>
      </Modal>

      <Toast show={updated} title={'職能項目已更改'} subtitle={`${status.category} - ${item}`} />
    </>
  );
};

export default ModalASK;
